import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from '@material-ui/core/SvgIcon'

import Icons from '../icons'

const Icon = (props, context) => {
  const { muiTheme } = context
  // eslint-disable-next-line react/prop-types
  const { width, height, margin, flipV, flipH } = props
  const type = muiTheme[props.type] || props.type
  const dataTestId = props['data-testid']

  const found = Icons[type] ? Icons[type].match(/viewBox="(\d*) (\d*) (\d*) (\d*)"/) : ''

  if (!found && type) {
    const imgStyle = { width, height, margin }
    const LogoImg = require(`!file-loader!image-webpack-loader?{"svgo":{"floatPrecision":1}}!../icons/${type}.svg`)

    return <img style={imgStyle} src={LogoImg} alt="" />
  }

  const isFound = found.length === 5

  let internals = {
    x: isFound ? parseInt(found[1], 10) : 0,
    y: isFound ? parseInt(found[2], 10) : 0,
    width: width || (isFound ? parseInt(found[3], 10) : '100%'),
    height: height || (isFound ? parseInt(found[4], 10) : '100%'),
    nativeColor: props.fill || muiTheme.palette.textColor,
    stroke: props.stroke,
    fillOpacity: props.opacity,
    margin: margin || '0',
    transform: `scale(${flipH ? -1 : 1}, ${flipV ? -1 : 1})`,
  }

  // eslint-disable-next-line no-nested-ternary
  internals.hoverColor =
    props.hover === true ? muiTheme.palette.hoverIconColor : props.hover ? props.hover : internals.color
  internals.viewBox = props.viewBox || `${found[1]} ${found[2]} ${found[3]} ${found[4]}`.replace('px', '')

  let styles = {
    ...props.style,
    minWidth: props.minWidth,
    maxWidth: props.maxWidth,
    width: internals.width,
    height: internals.height,
    margin: internals.margin,
  }

  if (props.cleanup) {
    styles = {
      width: '100%',
      height: '100%',
    }
    internals = {
      viewBox: internals.viewBox,
      color: internals.color,
      hoverColor: internals.hoverColor,
    }
  }

  const dangerouslySetInnerHTML = { __html: Icons[type] }

  return (
    <SvgIcon className={props.className} style={styles} {...internals} data-testid={dataTestId}>
      <g dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
    </SvgIcon>
  )
}

Icon.contextTypes = {
  muiTheme: PropTypes.object,
}

Icon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.any,
  cleanup: PropTypes.bool,
  hover: PropTypes.bool,
  style: PropTypes.object,
  minWidth: PropTypes.string,
  maxWidth: PropTypes.string,
  fill: PropTypes.any,
  stroke: PropTypes.any,
  opacity: PropTypes.any,
  viewBox: PropTypes.string,
}

export default Icon
